import React from "react";
import styled from "styled-components";
import { AlertBox, LinkText, Text } from "@origin-digital/style-guide";
export var UndoLink = styled(LinkText).withConfig({
  displayName: "DismissMessage__UndoLink",
  componentId: "sc-1l2tx1f-0"
})(["text-decoration:underline;&:hover{cursor:pointer;}"]);
export var DismissMessage = function DismissMessage(_ref) {
  var undoHide = _ref.undoHide,
      text = _ref.text;
  return React.createElement(AlertBox, {
    type: "success",
    markdown: true
  }, React.createElement(Text, {
    inline: true,
    size: "sm"
  }, text, " ", React.createElement(UndoLink, {
    "data-id": "undo-dismiss",
    onClick: undoHide,
    text: "Undo"
  })));
};